import { useContext } from "react";
import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import { ProductServerAuthContext } from "../../providers/ProductServerAuth";

@AttributeGroup({ title: 'AuthStateV2', blockName: 'AuthStateV2', module: 'auth' })
export class AuthStateAttributes extends Attribute {

    @AttributeProperty({ type: 'Select', selectOptions: ['all', 'loggedIn', 'loggedOut'] })
    authState: string = 'all';
}

const AuthStateTheme = styled.div((props: { attributes: AuthStateAttributes }) => `

    ${props.attributes.toCSS()}

`);

function AuthStateV2(props: ComponentProps<AuthStateAttributes>) {

    const { isLoggedIn, isLoginDialogOpen, setLoginDialogOpen, login, logout } = useContext(ProductServerAuthContext);

    return (
        <>
            {(props.attributes.authState == 'all' || (props.attributes.authState == 'loggedIn' && isLoggedIn) || (props.attributes.authState == 'loggedOut' && !isLoggedIn)) ? props.children : <></>}
        </>
    )
}


AuthStateV2.prototype.Props = AuthStateAttributes;


export default AuthStateV2;